import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home.svg'
import _imports_1 from '@/assets/img/close.svg'
import _imports_2 from '@/assets/img/location.svg'
import _imports_3 from '@/assets/img/phone.svg'
import _imports_4 from '@/assets/img/back_arrow.svg'
import _imports_5 from '@/assets/img/location.pin.svg'
import _imports_6 from '@/assets/img/down_arrow.svg'
import _imports_7 from '@/assets/img/location.alt.svg'


const _withScopeId = n => (_pushScopeId("data-v-2c4c1fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "markerDetailContainer",
  ref: "markerDetailContainer"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "d-flex justify-content-between mb-3",
  ref: "header"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "fs_12 fw_500 d-flex align-items-center mt-3 mb-4" }
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_9 = { class: "ms-2 me-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-2 me-1" }, "-------------")
], -1))
const _hoisted_11 = { class: "d-flex align-items-center my-4 pb-3" }
const _hoisted_12 = { class: "me-5" }
const _hoisted_13 = { class: "fs_12 fw_500 marine" }
const _hoisted_14 = { class: "me-5" }
const _hoisted_15 = { class: "fs_12 fw_500 marine" }
const _hoisted_16 = {
  class: "mb-4",
  ref: "searchCTA"
}
const _hoisted_17 = {
  key: 0,
  class: "ticketsContainer mt-4"
}
const _hoisted_18 = {
  key: 1,
  class: "ticketsContainer mt-4"
}
const _hoisted_19 = {
  key: 2,
  class: "ticketsContainer mt-4"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_24 = { class: "ms-2" }
const _hoisted_25 = { class: "fs_12 fw_500 d-block" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "me-2"
}, null, -1))
const _hoisted_27 = { class: "radiusContainer mb-4" }
const _hoisted_28 = { class: "d-flex flex-wrap" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "resultsHeader" }
const _hoisted_31 = { class: "fs_14 fw_700" }
const _hoisted_32 = { class: "resultsContainer" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "placeFilter smallImage mb-0" }
const _hoisted_37 = { class: "fw_700 ms-2 me-3" }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "me-2"
}, null, -1))
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_43 = { class: "ms-2" }
const _hoisted_44 = { class: "fs_12 fw_500" }
const _hoisted_45 = { class: "d-flex align-items-center my-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_47 = { class: "roundContainer ms-2" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_50 = { class: "ms-2" }
const _hoisted_51 = { class: "fs_12 fw_500" }
const _hoisted_52 = {
  key: 0,
  class: "mapsRouteSentContainer mt-4"
}
const _hoisted_53 = { class: "d-flex align-items-center mt-2" }
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "textContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_time_filter_container = _resolveComponent("time-filter-container")!
  const _component_ticket_card = _resolveComponent("ticket-card")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_technicians_images = _resolveComponent("technicians-images")!
  const _component_technician_detail_info = _resolveComponent("technician-detail-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_localized_text, {
                class: "fw_500 marine ms-1",
                localizedKey: "Building",
                text: "Building"
              })
            ]),
            _createElementVNode("img", {
              src: _imports_1,
              class: "pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            })
          ], 512),
          _createElementVNode("h1", null, _toDisplayString(_ctx.model.name), 1),
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_localized_text, {
              class: "fs_12 fw_500 me-1",
              localizedKey: "Building id:",
              text: "Building id:"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.model.bl_id), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.fullAddress), 1),
            _createVNode(_component_copy_button, { text: _ctx.fullAddress }, null, 8, ["text"])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_localized_text, {
                class: "fs_12 fw_500 me-1",
                localizedKey: "Site id:",
                text: "Site id:"
              }),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.model.site_id), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_localized_text, {
                class: "fs_12 fw_500 me-1",
                localizedKey: "Complex id:",
                text: "Complex id:"
              }),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.model.complex_id), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "button btn-primary w-100",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchForTechnicians()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cerca tecnico",
                text: "Cerca tecnico"
              })
            ])
          ], 512),
          _createVNode(_component_time_filter_container, {
            onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.timeFilter = $event))
          }),
          (_ctx.timeFilter == 'Previous')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_ctx.previousTickets.length == 0)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      class: "pt-4 text-center d-block",
                      localizedKey: "Nessun ticket passato",
                      text: "Nessun ticket passato"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previousTickets, (ticket, index) => {
                  return (_openBlock(), _createBlock(_component_ticket_card, {
                    ticket: ticket,
                    key: index
                  }, null, 8, ["ticket"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.timeFilter == 'Live')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.liveTickets.length == 0)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      class: "pt-4 text-center d-block",
                      localizedKey: "Nessun ticket presente",
                      text: "Nessun ticket presente"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.liveTickets, (ticket, index) => {
                  return (_openBlock(), _createBlock(_component_ticket_card, {
                    ticket: ticket,
                    key: index
                  }, null, 8, ["ticket"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.timeFilter == 'Next')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_ctx.nextTickets.length == 0)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      class: "pt-4 text-center d-block",
                      localizedKey: "Nessun ticket futuro",
                      text: "Nessun ticket futuro"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextTickets, (ticket, index) => {
                  return (_openBlock(), _createBlock(_component_ticket_card, {
                    ticket: ticket,
                    hideDate: true,
                    key: index
                  }, null, 8, ["ticket"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_localized_text, {
                  class: "fs_12 fw_500 marine d-block",
                  localizedKey: "Cerca tecnico",
                  text: "Cerca tecnico"
                }),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.model.name), 1)
              ])
            ]),
            _createElementVNode("img", {
              src: _imports_1,
              class: "pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            })
          ]),
          _createElementVNode("button", {
            class: "button btn-secondary mb-4",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step = 1))
          }, [
            _hoisted_26,
            _createVNode(_component_localized_text, {
              localizedKey: "Indietro",
              text: "Indietro"
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_form_field, {
              type: "range",
              min: 5,
              max: 20,
              step: 5,
              modelValue: _ctx.radiusKm,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.radiusKm) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: _normalizeClass(["placeFilter smallImage", {'active': _ctx.techniciansTypeFilters.length == 0}]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.techniciansTypeFilters = []))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Tutti",
                text: "Tutti",
                class: "me-1"
              }),
              _createTextVNode(" (" + _toDisplayString(_ctx.technicians.length) + ") ", 1)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.techniciansTypeList, (techType, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["placeFilter smallImage", {'active': _ctx.checkIfActive(techType)}]),
                key: index,
                onClick: ($event: any) => (_ctx.toggleFilterType(techType))
              }, [
                _createVNode(_component_technicians_images, {
                  role: techType,
                  isActive: _ctx.checkIfActive(techType)
                }, null, 8, ["role", "isActive"]),
                _createVNode(_component_localized_text, {
                  localizedKey: techType.toLowerCase(),
                  text: techType.toLowerCase(),
                  class: "text-capitalize mx-1"
                }, null, 8, ["localizedKey", "text"]),
                _createTextVNode(" (" + _toDisplayString(_ctx.getFiltersLength(techType)) + ") ", 1)
              ], 10, _hoisted_29))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_localized_text, {
              localizedKey: "Risultati:",
              text: "Risultati:",
              class: "fs_14 me-1"
            }),
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.filteredTechnicians.length), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTechnicians, (tech, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "radiusContainer",
                key: index,
                onClick: ($event: any) => (_ctx.selectTechnician(tech))
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_technicians_images, {
                        role: tech.role
                      }, null, 8, ["role"]),
                      (tech.role)
                        ? (_openBlock(), _createBlock(_component_localized_text, {
                            key: 0,
                            localizedKey: tech.role.toLowerCase(),
                            text: tech.role.toLowerCase(),
                            class: "text-capitalize mx-1"
                          }, null, 8, ["localizedKey", "text"]))
                        : (_openBlock(), _createBlock(_component_localized_text, {
                            key: 1,
                            localizedKey: "Polivalente",
                            text: "Polivalente",
                            class: "text-capitalize mx-1"
                          }))
                    ]),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$filters.approximation(tech.distance)) + "km", 1)
                  ])
                ])
              ], 8, _hoisted_33))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              class: "button btn-secondary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.step = 2))
            }, [
              _hoisted_40,
              _createVNode(_component_localized_text, {
                localizedKey: "Indietro",
                text: "Indietro"
              })
            ]),
            _createElementVNode("img", {
              src: _imports_1,
              class: "pointer",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
            })
          ]),
          _createVNode(_component_technician_detail_info, { technicianDetail: _ctx.technicianDetails }, null, 8, ["technicianDetail"]),
          _createElementVNode("button", {
            class: "button btn-primary w-100 mt-3 mb-4",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sendPath()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Invia percorso",
              text: "Invia percorso"
            })
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_localized_text, {
                class: "fs_10 fw_500 lightgrey d-block",
                localizedKey: "Tecnico",
                text: "Tecnico"
              }),
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.selectedPosition.coordinate.coordinate.latitude) + ", " + _toDisplayString(_ctx.selectedPosition.coordinate.coordinate.longitude), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$filters.approximation(_ctx.selectedPosition.distance)) + "km", 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_localized_text, {
                class: "fs_10 fw_500 lightgrey d-block",
                localizedKey: "Building",
                text: "Building"
              }),
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.fullAddress), 1)
            ])
          ]),
          (_ctx.googleMapsUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createVNode(_component_localized_text, {
                  class: "fs_10 fw_500 lightgrey d-block",
                  localizedKey: "Percorso da inviare",
                  text: "Percorso da inviare"
                }),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_copy_button, { text: _ctx.googleMapsUrl }, null, 8, ["text"]),
                  _createElementVNode("a", {
                    href: _ctx.googleMapsUrl,
                    target: "_blank",
                    class: "fs_12 fw_500 mapsUrl ms-2"
                  }, _toDisplayString(_ctx.googleMapsUrl), 9, _hoisted_54)
                ]),
                (_ctx.showGoogleMapsRouteSent)
                  ? (_openBlock(), _createBlock(_Transition, {
                      key: 0,
                      name: "opacity",
                      class: "duration04 no_leave_animation",
                      appear: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Email inviata correttamente",
                            text: "Email inviata correttamente"
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}